import { AlessiaRepo } from "./AlessiaRepo";

export const AlessiaRepoImpl = (token?: string): AlessiaRepo => {
    const setDefaultBu = async (bu: string, email: string) => {
    };

    return {
        setDefaultBu: setDefaultBu,
    };
};
